/**
 * Interfaces de plano de aula
 */

export interface IdPlanoDeAula {
  ID_PLANO_AULA: number;
}

export interface PlanoAulaRequest {
  ID_PLANO_AULA: number;
  CDESCOLA: number;
  CPF: string;
  BIMESTRE: number;
  EXERC?: number;
  SITUACAO?: number;
  ID_TURMA: number;
  TIPOPERIODO?: string;
  DATAINICIO?: string;
  DATAFINAL?: string;
  TITULOTEMA?: string;
  LOCAL?: string;
  DURACAOATIVIDADE?: string;
  CONHECIMENTOPREVIO?: string;
  OBJETIVO?: string;
  METODOSEXTRATEGIAS?: string;
  AVALIACAO?: string;
  REFERENCIASBIBLIOGRAFICAS?: string;
  OBSERVACOES?: string;
  OBSERVACOESCOORDENADOR?: string;
  SUBTEMAS?: string;
  NOMEUSUARIO?: string;
  CRIADO_POR_IA?: number;
}

export type ListaPlanoAulaPorId = PlanoAulaPorId[];

export interface PlanoAulaPorId {
  ID_PLANO_AULA: number;
  CDESCOLA: number;
  CPF: string;
  BIMESTRE: number;
  EXERC: string;
  SITUACAO: number;
  ID_TURMA: number;
  TIPOPERIODO: number;
  DESCRICAO_PERIODO: string;
  DATAINICIO: string;
  DATAFINAL: string;
  DATACONCLUSAO?: Date;
  TITULOTEMA: string;
  LOCAL: string;
  DURACAOATIVIDADE: string;
  CONHECIMENTOPREVIO: string;
  OBJETIVO: string;
  METODOSEXTRATEGIAS: string;
  AVALIACAO: string;
  REFERENCIASBIBLIOGRAFICAS: string;
  OBSERVACOES: string;
  OBSERVACOESCOORDENADOR: string;
  SUBTEMAS: string;
  SERIE: string;
  CDTURMA: string;
  TURNO: string;
  PROFESSOR: string;
  DATACADASTRO: string;
  DATAATUALIZADO: string;
  NOMEUSUARIO: string;
  ID_ERGON: number;
  UNIDADESTEMATICAS: string;
  CRIADO_POR_IA?: number;
}

export type ListaPlanoDeAulaDisciplina = PlanoDeAulaDisciplina[];

export interface PlanoDeAulaDisciplina {
  ID_PLANO_AULA_DISC: number;
  ID_PLANO_AULA: number;
  CDDISC: number;
  DATACADASTRO: string;
  DATAATUALIZADO: string;
  NOMEUSUARIO: string;
  ID_ERGON: number;
  QTDE_AULA: number;
  IDAREACOMPONENTE: number;
  DSDISC: string;
  ETAPA_BNCC: number;
  ETAPA_BNCC_SERIE: number;
  TIPODISCIPLINA: string;
  QTDE_VINCULO: number;
  DSCOMPONENTECAMPOEXPERIENCIA: string;
  CDTPDISC: number;
}

export type ListaPlanoAulaAtividade = PlanoAulaAtividade[];

export interface PlanoAulaAtividade {
  ID_ATIVIDADE: number;
  ID_PLANO_AULA_ATIVIDADE: number;
  ID_PLANO_AULA: number;
  DATACADASTRO: string;
  DATAATUALIZADO: string;
  NOMEUSUARIO: string;
  ID_ERGON: number;
  DSATIVIDADE: string;
  OBSERVACOES?: string;
}

export type ListaPlanoAulaRecurso = PlanoAulaRecurso[];

export interface PlanoAulaRecurso {
  ID_PLANO_AULA_RECURSOS: number;
  ID_PLANO_AULA: number;
  ORDEM: number;
  ID_RECURSO: number;
  DATACADASTRO: string;
  DATAATUALIZADO: string;
  NOMEUSUARIO: string;
  ID_ERGON: number;
  TIPO: string;
  RECURSO: string;
}

/**
 * Request para buscar plano de aula por ID
 */
export interface GetPlanoAulaPorIdRequest {
  ID_PLANO_AULA: number;
  DATABASE: string;
}

/**
 * Request para salvar plano de aula
 */
export interface SavePlanoAulaRequest {
  json: string;
  DATABASE: string;
}

/**
 * Request para gerar ID de plano de aula
 */
export interface GerarIdRequest {
  CPF: string;
  DATABASE: string;
}

/**
 * Request para voltar ID de plano de aula
 */
export interface VoltarIdRequest {
  CPF: string;
  DATABASE: string;
}

/**
 * Request para consulta de planos de aula (getAll)
 */
export interface GetAllPlanosRequest {
  DATABASE: string;
  CDESCOLA: number;
  ANO: number;
  CPF?: string;
  CPF_COORDENADOR?: string;
  CDDISC?: number;
  BIMESTRE?: number;
  ID_TURMA?: number;
  DATAINICIO?: string;
  DATAFINAL?: string;
  ID_PLANO_AULA?: number;
}

/**
 * Request para planos excluídos
 */
export interface GetPlanosExcluidosRequest {
  CPF: string;
  CDESCOLA: number;
  ANO: number;
  DATABASE: string;
}

export interface GetPlanoAulaOutraEscolaRequest {
  CPF: string;
  CDESCOLA: number;
  ANO: number;
  BIMESTRE: number;
  DATABASE: string;
}

export interface PlanoAulaOutraEscola {
  ID_PLANO_AULA: number;
  CDESCOLA: number;
  CDSERIE: number;
  ESCOLA: string;
  DATAINICIO: string;
  DATAFINAL: string;
  TEMA: string;
  CURSO: string;
  SERIE: string;
  TURMA: string;
  TURNO: string;
}

export type ListaPlanoAulaOutraEscola = PlanoAulaOutraEscola[];

export interface GetImportarPlanoAulaOutraEscolaRequest {
  ID_PLANO_AULA_ORIGEM: number;
  CDESCOLAORIGEM: number;
  CDESCOLADESTINO: number;
  CPF: string;
  ID_TURMA_DESTINO: number;
  DATABASE: string;
}

export interface GetPlanoAulaPeriodoTurmaRequest {
  CDESCOLA: number;
  ID_TURMA: number;
  CPF: string;
  BIMESTRE: number;
  DATABASE: string;
}

export interface PlanoAulaPeriodoTurma {
  DATAINICIO: string;
  DATAFINAL: string;
}
